export default __webpack_public_path__ + "static/media/fb.516738a1.webp";